import { useFormContext } from "react-hook-form";
import FormItemInfo from "pages/shipper/RequestForm/components/Common/FormItemInfo";

type IScheduleAddress = {
  isPickupOrDelivery: string;
  showFormLabel?: boolean;
};

function ScheduleAddress({ showFormLabel, isPickupOrDelivery }: IScheduleAddress) {
  const methods = useFormContext();
  const { schedule } = methods.getValues();
  const {
    pickup_company_name,
    pickup_street,
    pickup_street_line2,
    pickup_city,
    pickup_country,
    pickup_zipcode,
    stop1_company_name,
    stop1_street,
    stop1_street_line2,
    stop1_city,
    stop1_country,
    stop1_zipcode,
  } = schedule || {};

  const companyName = isPickupOrDelivery === "pickup" ? pickup_company_name || "" : stop1_company_name || "";
  const street = isPickupOrDelivery === "pickup" ? pickup_street || "" : stop1_street || "";
  const streetLine2 = isPickupOrDelivery === "pickup" ? pickup_street_line2 || "" : stop1_street_line2 || "";
  const cityName = isPickupOrDelivery === "pickup" ? pickup_city || "" : stop1_city || "";
  const countryName = isPickupOrDelivery === "pickup" ? pickup_country || "" : stop1_country || "";
  const zipcode = isPickupOrDelivery === "pickup" ? pickup_zipcode || "" : stop1_zipcode || "";

  const address = (
    <div>
      {companyName} {street} {streetLine2} {cityName}, {zipcode} {countryName}
    </div>
  );
  if (!showFormLabel) return address;

  return (
    <div className="d-flex flex-row mb-3xl">
      <div className="w-200 flex-shrink-0">
        <FormItemInfo
          labelId={`${
            isPickupOrDelivery === "pickup" ? "new-request.schedule.pickupAddress" : "new-request.schedule.deliveryAddress"
          }`}
          label={`${isPickupOrDelivery === "pickup" ? "Pickup address" : "Delivery address"}`}
          descId={`${
            isPickupOrDelivery === "pickup"
              ? "new-request.schedule.pickupLocationInfo"
              : "new-request.schedule.deliveryLocationInfo"
          }`}
          description={`${
            isPickupOrDelivery === "pickup" ? "Provide your pickup location info" : "Provide your delivery location info"
          }`}
        />
      </div>
      <div className="font-b3">{address}</div>
    </div>
  );
}

export default ScheduleAddress;

ScheduleAddress.defaultProps = {
  showFormLabel: true,
};
